import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormTextField } from '../../formComponents/FormTextField';
import { OrderPagePrice } from '../../OrderPageSettingsPage';

type BasePricingFieldsProps = {
  price: OrderPagePrice;
  index: number;
  formIsDisabled: boolean;
  currencySymbol: string;
  /** The order page's name for one unit; empty falls back to participant wording. */
  unitLabel?: string;
};

export const BasePricingFields: React.FC<BasePricingFieldsProps> = ({
  price,
  index,
  formIsDisabled,
  currencySymbol,
  unitLabel,
}) => {
  const { t } = useTranslation();

  return (
    <Grid container flexDirection="column" gap={2}>
      <Grid container alignItems="center" gap={1}>
        <Grid item>
          <Typography>{t('editOrderPage.basePrice')}</Typography>
        </Grid>
        <Grid item>
          <FormTextField
            type="number"
            isFieldUpdate
            width={100}
            fieldName={`price[${index}].base_price`}
            disabled={formIsDisabled}
            label={''}
            endAdornment={currencySymbol}
          />
        </Grid>
        <Typography>{t('editOrderPage.for')}</Typography>
        <Grid item>
          <FormTextField
            type="number"
            isFieldUpdate
            width={50}
            fieldName={`price[${index}].base_value`}
            disabled={formIsDisabled}
            label={''}
          />
        </Grid>
        <Grid item>
          <Typography>
            {/* A renamed unit has no plural form on file, so it stands for both counts. */}
            {unitLabel ||
              (price.base_value && price.base_value > 1 ? t('editOrderPage.persons') : t('editOrderPage.person'))}
          </Typography>
        </Grid>
      </Grid>
      <Grid container alignItems="center" gap={1}>
        <Typography>
          {unitLabel ? t('editOrderPage.forAdditionalUnit', { unit: unitLabel }) : t('editOrderPage.forAdditional')}
        </Typography>
        <Grid item>
          <FormTextField
            type="number"
            isFieldUpdate
            width={100}
            fieldName={`price[${index}].price_per_additional_value`}
            disabled={formIsDisabled}
            endAdornment={currencySymbol}
            label={''}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
